import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentPrevious = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.66797 10H4.66797L6.0013 11.3333",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.66797 10.0003L6.0013 8.66699",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6654 6.66634V9.99967C14.6654 13.333 13.332 14.6663 9.9987 14.6663H5.9987C2.66536 14.6663 1.33203 13.333 1.33203 9.99967V5.99967C1.33203 2.66634 2.66536 1.33301 5.9987 1.33301H9.33203",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6654 6.66634H11.9987C9.9987 6.66634 9.33203 5.99967 9.33203 3.99967V1.33301L11.9987 3.99967L14.6654 6.66634Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDocumentPrevious;
